<!--div style="padding-top:10px;">  
    <alert *ngFor="let alert of alerts; let i = index" [type]="alert.type" dismissible="true" (close)="closeAlert(i)">
        <div [innerHTML]="messageBox"></div>       
    </alert>    
</div>-->
<div class="row">
  <section
    class="col-xs-12 scyr-section-avisos"
    id="avisosAccordion"
  >
    <section
      *ngIf="typeException == 0"
      class="scyr-avisos"
    >
      <div class="warn yellow box fade">
        <img
          src="assets/images/icons/averias.svg"
          alt=""
        />
        <div class="scy-avisos__texto">
          <div class="collapsible-header">
            <a aria-controls="exampleAccordion2">
              <h2>
                <span class="title">{{messageBox}}</span>
              </h2>
            </a>
          </div>
          <!--<div class="collapsible-body collapse" id="avisosAccordion2" role="tabpanel">-->
          <div
            id="avisosAccordion2"
            role="tabpanel"
          >
            <p>{{messageComplet}}</p>
            <!--<p [innerHTML]='messageComplet'></p>-->
            <div class="onlyMobileLandscape scy-avisos__texto_close">
              <!--<a (click)='CerrarVentana()' id="close-yellow">Cerrar aviso</a>-->
            </div>
          </div>
        </div>
        <button
          (click)='CerrarVentana()'
          type="button"
          class="close close-aviso "
          id="close-yellow2"
        >
          <img
            src="assets/images/icons/cross-blue.svg"
            alt=""
          />
          <span class="sr-only">Cerrar aviso</span>
        </button>
      </div>
    </section>
    <section
      *ngIf="typeException == 2"
      class="scyr-avisos"
    >
      <div class="warn blue box fade">
        <img
          src="assets/images/icons/tramites.svg"
          alt=""
        />
        <div class="scy-avisos__texto">
          <div class="collapsible-header">
            <a aria-controls="exampleAccordion1">
              <h2>
                <span class="title">{{messageBox}}</span>
              </h2>
            </a>
          </div>
          <!--<div class="collapsible-body collapse" id="avisosAccordion1" role="tabpanel">-->
          <div
            id="avisosAccordion1"
            role="tabpanel"
            [innerHTML]='messageComplet'
          >
            <!--<p>{{messageComplet}}</p>-->
            <div class="onlyMobileLandscape scy-avisos__texto_close">
              <!-- <a href="#" id="close-blue">Cerrar aviso</a>-->
            </div>
          </div>
        </div>
        <button
          type="button"
          (click)='CerrarVentana()'
          class="close close-aviso"
          id="close-blue2"
        >
          <img
            src="assets/images/icons/cross-blue.svg"
            alt=""
          />
          <span class="sr-only">Cerrar aviso</span>
        </button>
      </div>
    </section>
    <section
      *ngIf="typeException == 1"
      class="scyr-avisos"
    >
      <div class="warn red box fade">
        <img
          src="assets/images/icons/wrong.svg"
          alt=""
        />
        <div class="scy-avisos__texto">
          <div class="collapsible-header">
            <a aria-controls="exampleAccordion3">
              <h2>
                <span class="title">{{messageBox}}</span>
              </h2>
            </a>
          </div>
          <!--<div class="collapsible-body collapse" id="avisosAccordion3" role="tabpanel">-->
          <div
            class=""
            id="avisosAccordion3"
            role="tabpanel"
          >
            <p>{{messageComplet}}</p>
            <div class="onlyMobileLandscape scy-avisos__texto_close">
              <!--<a href="#" id="close-red">Cerrar aviso</a>-->
            </div>
          </div>
        </div>
        <button
          type="button"
          (click)='CerrarVentana()'
          class="close close-aviso untilMobileLandscape"
          id="close-red2"
        >
          <img
            src="assets/images/icons/cross-blue.svg"
            alt=""
          />
          <span class="sr-only">Cerrar aviso</span>
        </button>
      </div>
    </section>
    <section
      *ngIf="typeException == 3"
      class="scyr-avisos"
    >
      <div class="warn red box fade">
        <img
          src="assets/images/icons/wrong.svg"
          alt=""
        />
        <div class="scy-avisos__texto">
          <div class="collapsible-header">
            <a aria-controls="exampleAccordion3">
              <h2>
                <span class="title">{{messageBox}}</span>
              </h2>
            </a>
          </div>
        </div>
        <button
          type="button"
          (click)='CerrarVentana()'
          class="close close-aviso untilMobileLandscape"
          id="close-red2"
        >
          <img
            src="assets/images/icons/cross-blue.svg"
            alt=""
          />
          <span class="sr-only">Cerrar aviso</span>
        </button>
      </div>
    </section>
    <section
      *ngIf="typeException == 5"
      class="scyr-avisos"
    >
      <div class="warn red login box fade">
        <div class="scy-avisos__texto">
          <img
            src="assets/images/icons/wrong.svg"
            alt=""
          />
          <p>{{messageComplet}}</p>
        </div>
      </div>
    </section>
    <section
      *ngIf="typeException == 6"
      class="scyr-avisos"
    >
      <div class="warn yellow box fade">
        <img
          src="assets/images/icons/averias.svg"
          alt=""
        />
        <div class="scy-avisos__texto">
          <div class="collapsible-header">
            <a aria-controls="exampleAccordion2">
              <h2>
                <span class="title">{{messageBox}}</span>
              </h2>
            </a>
          </div>
          <p>Hemos encontrado problemas para realizar el cobro de una de sus
            <a (click)='Navegar("/home/consumofactura")'>facturas</a>. Revise los
            <a (click)='Navegar("/home/domiciliacionFactura")'>datos de domiciliación</a> por si debe actualizarlos y
            ante cualquier consulta no dude en
            <a (click)='Navegar("/home/contact")'>contactar con nosotros</a>.
          </p>
          <p>
            <br />
            <a (click)="_showModalPago=true">
              <span><strong>Pague sus facturas desde esta página, ¿Quiere saber cómo? Haga clic</strong></span>
            </a>
          </p>
          <div
            id="avisosAccordion2"
            role="tabpanel"
          >
            <div class="onlyMobileLandscape scy-avisos__texto_close">
            </div>
          </div>
        </div>
        <button
          (click)='CerrarVentana()'
          type="button"
          class="close close-aviso "
          id="close-yellow2"
        >
          <img
            src="assets/images/icons/cross-blue.svg"
            alt=""
          />
          <span class="sr-only">Cerrar aviso</span>
        </button>
      </div>
    </section>
    <section
      *ngIf="typeException == 7"
      class="scyr-avisos"
    >
      <div class="warn red box fade">
        <img
          src="assets/images/icons/wrong.svg"
          alt=""
        />
        <div class="scy-avisos__texto">
          <div class="collapsible-header">
            <a aria-controls="exampleAccordion3">
              <h2>
                <span class="title">{{messageBox}}</span>
              </h2>
              <p> <br />
                <a (click)="_showModalPagoCorte=true">
                  <span><strong>Puede pagar su deuda desde esta página, ¿Quiere saber cómo? Haga clic</strong></span>
                </a>
              </p>
            </a>
          </div>
        </div>
        <button
          type="button"
          (click)='CerrarVentana()'
          class="close close-aviso untilMobileLandscape"
          id="close-red2"
        >
          <img
            src="assets/images/icons/cross-blue.svg"
            alt=""
          />
          <span class="sr-only">Cerrar aviso</span>
        </button>
      </div>
    </section>
    <section
      *ngIf="typeException == 8"
      class="scyr-avisos"
    >
      <div class="warn red box fade">
        <img
          src="assets/images/icons/wrong.svg"
          alt=""
        />
        <div class="scy-avisos__texto">
          <div class="collapsible-header">
            <a aria-controls="exampleAccordion3">
              <h2>
                <span class="title">{{messageBox}}</span>
              </h2>
              <p> <br />
                <span><strong>Existe una baja por impago en curso, no podrá realizar el pago de las facturas desde esta
                    plataforma. Debe asistir a la oficina para regularizar su situación</strong></span>
              </p>
            </a>
          </div>
        </div>
        <button
          type="button"
          (click)='CerrarVentana()'
          class="close close-aviso untilMobileLandscape"
          id="close-red2"
        >
          <img
            src="assets/images/icons/cross-blue.svg"
            alt=""
          />
          <span class="sr-only">Cerrar aviso</span>
        </button>
      </div>
    </section>
    <section
      *ngIf="typeException == 9"
      class="scyr-avisos"
    >
      <div class="warn blue box fade">
        <div class="scy-avisos__texto">
          <div class="collapsible-header">
            <a aria-controls="exampleAccordion1">
              <h2>
                <span class="title">{{messageBox}}</span>
              </h2>
            </a>
          </div>
          <!--<div class="collapsible-body collapse" id="avisosAccordion1" role="tabpanel">-->
          <div
            id="avisosAccordion1"
            role="tabpanel"
            [innerHTML]='messageComplet'
          >
            <!--<p>{{messageComplet}}</p>-->
            <div class="onlyMobileLandscape scy-avisos__texto_close">
              <!-- <a href="#" id="close-blue">Cerrar aviso</a>-->
            </div>
          </div>
        </div>
        <button
          type="button"
          (click)='CerrarVentana()'
          class="close close-aviso"
          id="close-blue2"
        >
          <img
            src="assets/images/icons/cross-blue.svg"
            alt=""
          />
          <span class="sr-only">Cerrar aviso</span>
        </button>
      </div>
    </section>
  </section>
</div>

<!-- MODAL -->
<sacyr-modal
  [setTemplateRef]="modal_content"
  [showModal]="showModal()"
  (closeModal)="closeModal()"
></sacyr-modal>

<ng-template #modal_content>

  <ng-container *ngIf="_showModalPago">
    <div id="modal_factura">
      <h2>Cómo pagar su factura</h2>
      <div class="modal-factura__texto">
        <ul class="col-xs-10">
          <li>Pulse sobre <strong>Consumo y facturas</strong> del menú lateral</li>
          <li>En el listado de facturas en la parte inferior, <strong>Pulse sobre la factura que quiere pagar en el
              icono
            </strong>
            <img src="assets/images/icons/averia-rojo.svg" /> <br />
          </li>

          <li>En la ventana emergente compruebe que el importe es correcto, y pulse en el enlace <strong>Clic para
              redireccionar a la pasarela de pago</strong></li>
          <li>Accederá a una <strong>página externa segura</strong> donde deberá introducir los datos de su tarjeta</li>
          <li>Una vez finalizado el pago se redirigirá nuevamente a la <strong>oficina virtual</strong></li>
        </ul>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="_showModalPagoCorte">
    <div id="modal_factura">
      <h2>Cómo pagar su deuda</h2>
      <div class="modal-factura__texto">
        <ul class="col-xs-10">
          <li>Pulse sobre <strong>Resumen</strong> del menú lateral</li>
          <li>Pulse el botón <strong>PAGAR DEUDA</strong> en el apartado de <strong>Su última factura</strong>. No podrá
            pagar
            facturas de forma individual</li>
          <li>En la ventana emergente compruebe que el importe es correcto, y pulsa en el enlace <strong>Clic para
              continuar
              con el pago</strong></li>
          <li>Accederá a una <strong>página externa segura</strong> donde deberá introducir los datos de su tarjeta</li>
          <li>Una vez finalizado el pago se redirigirá nuevamente a la <strong>oficina virtual</strong></li>
        </ul>
      </div>
    </div>
  </ng-container>

</ng-template>
